// North Bay Round 2 (tournament node ownership) cutover: replaces the tournaments portion of
// App.jsx's watchDoc mechanism, which used to be:
//   watchDoc("tournaments", setTournaments, d=>dedupeIds(d.tournaments||d.items||[]))
// and subscribed to the single warriors/tournaments document, reading its `tournaments` array
// field. This module instead subscribes to the tournaments/{id} collection (one document per
// tournament, doc ID = the tournament's existing id — already live since the 2026-08-24 Phase A/B
// migration, dual-written in parallel this whole time, confirmed 58/58 matching production) and
// reconstructs an equivalent in-memory array. warriors/tournaments is now a frozen historical
// snapshot; nothing writes to it anymore as of this cutover.
//
// Unlike teams/players, there is no node-scoped read variant here — tournaments/{id}'s own
// firestore.rules read rule (`isAllowed() || isParent()`) is deliberately unscoped: every node's
// families/coaches need to see every tournament regardless of owner, same reasoning the rules file
// itself documents at the match block. Only create/update/delete are node-restricted.
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Converts one tournaments/{id} document into the shape the app's in-memory `tournaments` array
// has always used. nodeId is kept (not stripped) — every write site already builds its payload
// from explicitly named fields, never a whole-object spread, so carrying nodeId through here can't
// leak it into a write that shouldn't have it (same confirmation already done for teams).
export function tournamentsDocToRecord(docId, data) {
  return { ...data, id: docId };
}

// Live-subscription replacement for watchDoc("tournaments", setTournaments, ...) — same ergonomics
// (takes the setter, returns an unsubscribe function).
export function watchTournamentsCollection(setter) {
  return onSnapshot(collection(db, 'tournaments'), (snap) => {
    setter(snap.docs.map((d) => tournamentsDocToRecord(d.id, d.data())));
  });
}
